import React from "react";
import PropTypes from "prop-types";

import ProductHeroIIButtonAddToCart from "./Buttons/ProductHeroIIButtonAddToCart";
import ProductHeroIIButtonAvatars from "./Buttons/ProductHeroIIButtonAvatars";
import ProductHeroIIButtonCreationFlow from "./Buttons/ProductHeroIIButtonCreationFlow";
import ProductHeroIIButtonLink from "./Buttons/ProductHeroIIButtonLink";

const ProductHeroIICta = (props) => {
  if (!props.productCtaButtonText) {
    return null;
  }

  if (props.prismicProduct.avatarCreation.enabled3) {
    return (
      <ProductHeroIIButtonAvatars
        productSlug={props.productSlug}
        productCtaButtonText={props.productCtaButtonText}
        avatarCreation={props.prismicProduct.avatarCreation}
        productAvatarCreation={props.productAvatarCreation}
      />
    );
  }

  if (props.productCreationFlow) {
    return (
      <ProductHeroIIButtonCreationFlow
        productCtaButtonText={props.productCtaButtonText}
        productCreationFlow={props.productCreationFlow}
      />
    );
  }

  if (props.prismicProduct.main.canvas2) {
    return (
      <ProductHeroIIButtonLink
        productCtaButtonText={props.productCtaButtonText}
        productSlug={props.productSlug}
        productLocales={props.prismicProduct.main.locales}
      />
    );
  }

  return (
    <ProductHeroIIButtonAddToCart
      productCtaButtonText={props.productCtaButtonText}
      productId={props.prismicProduct.main.productId}
    />
  );
};

ProductHeroIICta.propTypes = {
  productSlug: PropTypes.string,
  productCtaButtonText: PropTypes.string,
  prismicProduct: PropTypes.object,
  productCreationFlow: PropTypes.object,
  productAvatarCreation: PropTypes.object,
};

export default ProductHeroIICta;
